
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import React, { useState, useEffect, useRef } from 'react';
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import CommonConfig from '../../../utils/constant';
import Toast from '../../Shared/Toast/Toast';
import { FloatLabel } from 'primereact/floatlabel';
import { ColorPicker } from 'primereact/colorpicker';
import { Dialog } from 'primereact/dialog';
import DeleteConfirmation from '../../Dialogs/DeleteConfirmation';
import { apiBase } from '../../../utils/config';
import UploadFile from '../../UploadFile/UploadFile';
import { useCatchResponse } from '../../../utils/useCatchResponse';

const AddHouseMasterDialog = (props) => {
    const { catchResponse } = useCatchResponse();
    const [houseName, setHouseName] = useState('');
    const fileUploadRef = useRef(null);
    const [securityUserID, setSecurityUserID] = useState("");
    const [houseNameErrText, setHouseNameErrText] = useState('');
    const [houseNameErr, setHouseNameErr] = useState(false);
    const [color, setColor] = useState(null);
    const [colorErr, setColorErr] = useState(false);
    const [colorErrText, setColorErrText] = useState('');
    const [nameColor, setNameColor] = useState(null);
    const [nameColorErr, setNameColorErr] = useState(false);
    const [nameColorErrText, setNameColorErrText] = useState('');
    const [backgroundImage, setBackgroundImage] = useState(null);
    const [previewProfilePath, setPreviewProfilePath] = useState('');
    const [isDeleteConfirmation, setIsDeleteConfirmation] = useState(false);


    const submitButtonRef = useRef(null);
    const houseNameRef = useRef(null);
    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);

        if (props.ID) {
            setHouseName(props?.masterData?.HouseName);
            setColor(props?.masterData?.ColorCode);
            setNameColor(props?.masterData?.NameColorCode);
            setBackgroundImage(props?.masterData?.BgImage ? `${apiBase}/TemplateBackGround/${props?.masterData?.BgImage}` : null);
        }

        // Delay focus until dialog has rendered
        setTimeout(() => {
            if (houseNameRef.current) {
                houseNameRef.current.focus();
            }
        }, 100);

    }, [props.visible]); // <- make sure you pass `visible` prop to control dialog open state


    useEffect(() => {
        const loginData = CommonConfig.loginData();
        setSecurityUserID(loginData?._id);
        if (props.ID) {
            setHouseName(props?.masterData?.HouseName);
            setColor(props?.masterData?.ColorCode);
            setNameColor(props?.masterData?.NameColorCode);
            setBackgroundImage(props?.masterData?.BgImage ? `${apiBase}/TemplateBackGround/${props?.masterData?.BgImage}` : null);
        }
    }, []);

    const onCancel = () => {
        props.onCancel();
        setHouseName('');
        setColor('');
        setNameColor('');
    }

    const validate = () => {
        let formIsValid = true;
        if (CommonConfig.isEmpty(houseName)) {
            formIsValid = false;
            setHouseNameErr(true);
            setHouseNameErrText("House Name is required");
        } else {
            setHouseNameErr(false);
            setHouseNameErrText("");
        }
        if (CommonConfig.isEmpty(color)) {
            formIsValid = false;
            setColorErr(true);
            setColorErrText("Color is required");
        } else {
            setColorErr(false);
            setColorErrText("");
        }
        return formIsValid;
    };

    const AddHouseMaster = async (e) => {
        if (validate(e)) {
            try {
                Loader.show();
                const formData = new FormData();
                formData.append("id", props.ID ?? '');
                formData.append('HouseName', houseName.trim().replace(/\s+/g, ' '));
                formData.append("ColorCode", color);
                formData.append("NameColorCode", nameColor);
                formData.append("CreatedBy", securityUserID);
                if (backgroundImage && backgroundImage.type) {
                    formData.append("BackGroundImage", backgroundImage);
                } else if (CommonConfig.isEmpty(backgroundImage)) {
                    formData.append("BgImage", '');
                }
                await api
                    .post(APIConstant.path.AddUpdateHouseMaster, formData, {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }).then((response) => {
                        let res = response;
                        if (res.success) {
                            Toast.success({ message: res.message });
                            Loader.hide();
                            onCancel();
                        } else {
                            Toast.error({ message: res.message });
                            Loader.hide();
                            // onCancel();
                        }
                    })
                    .catch((err) => {
                        Toast.error({ message: err?.data?.message });
                        Loader.hide();
                        onCancel();
                    });
            } catch (err) {
                console.log(err);
                Loader.hide();
                onCancel();
                catchResponse(err);
            }
        }
    };

    const handleChange = (e, type) => {
        const value = e.target.value;
        const alphanumericValue = value.replace(/[^a-zA-Z0-9\s!@#$%^&*\u0A80-\u0AFF\u0900-\u097F\s]/g, '');
        setHouseName(alphanumericValue);
    };

    const handleBackGroundImage = (e) => {
        const selectedFile = e.files[0];
        if (selectedFile) {
            const img = new Image();
            img.onload = () => {
                if (img.width === img.height) {
                    setBackgroundImage(selectedFile);
                    const fileURL = URL.createObjectURL(selectedFile);
                    setPreviewProfilePath(fileURL);
                } else {
                    if (fileUploadRef.current) {
                        fileUploadRef.current.clear();
                    }
                    Toast.error({ message: 'The image must have a 1:1 aspect ratio.' });
                }
            };
            img.onerror = () => {
                if (fileUploadRef.current) {
                    fileUploadRef.current.clear();
                }
                Toast.error({ message: 'Error loading the image.' });
            };

            const reader = new FileReader();
            reader.onload = (event) => {
                img.src = event.target.result;
            };
            reader.readAsDataURL(selectedFile);
        }
    };

    const renderFooter = () => (
        <div className="dialog-footer p-d-flex p-ai-center p-jc-end">
            <Button
                label="Cancel"
                className="btn-text-action-secondary"
                onClick={handleClose}
            />
            <Button
                label="Delete"
                className="btn-text-action-primary"
                onClick={() => {
                    handleClose();
                    setBackgroundImage("")
                    setPreviewProfilePath()
                    if (fileUploadRef.current) {
                        fileUploadRef.current.clear();
                    }
                }}
            />
        </div>
    );

    const handleClose = () => {
        setIsDeleteConfirmation(false)
    };

    const handleColorChange = (e, type) => {
        const newColor = e?.value ?? e?.target?.value;
        if (type === 'ColorCode') {
            setColor(newColor);
            setColorErr(false);
        } else {
            setNameColor(newColor);
            setNameColorErr(false);
        }
    };

    const handleInputChange = (e, type) => {
        let inputValue = e.target?.value?.trim();
        const alphanumericValue = inputValue.replace(/[^a-zA-Z0-9\s]/g, '');
        if (type === 'ColorCode') {
            setColor(alphanumericValue);
            if (/^[0-9A-F]{6}$/.test(alphanumericValue)) {
                setColorErr(false);
            } else {
                setColorErr(true);
                setColorErrText("Enter a valid 6-character HEX color (e.g., A1B2C3).");
            }
        } else {
            setNameColor(alphanumericValue);
            if (/^[0-9A-F]{6}$/.test(alphanumericValue)) {
                setNameColorErr(false);
            } else {
                setNameColorErr(true);
                setNameColorErrText("Enter a valid 6-character HEX color (e.g., A1B2C3).");
            }
        }
    };

    const handleDelete = (e) => {
        setIsDeleteConfirmation(true)
    };

    return (
        <div className="p-d-flex p-flex-column p-jc-between">
            <div className='p-grid'>
                <div className="p-col-12 p-md-4 p-pt-2">
                    <div className="e-add-fee-structure p-mt-3">
                        <div className="custom-inputs">
                            <label className='' htmlFor="houseName">House Name<span style={{ color: "red" }}>*</span></label>
                            <FloatLabel>
                                {/* <InputText
                                className="p-mt-2 p-w-100"
                                id="houseName"
                                type="text"
                                maxLength={20}
                                placeholder="House Name"
                                value={houseName}
                                autoFocus={true}
                                onChange={(e) => handleChange(e)}
                            /> */}
                                <InputText
                                    ref={houseNameRef}
                                    className="p-mt-2 p-w-100"
                                    id="houseName"
                                    type="text"
                                    maxLength={20}
                                    placeholder="House Name"
                                    value={houseName}
                                    onChange={(e) => handleChange(e)}
                                />
                            </FloatLabel>
                        </div>
                        <span className="error-msg" style={{ color: 'red' }}>
                            {houseNameErr ? houseNameErrText : null}
                        </span>
                    </div>
                </div>
                <div className="p-col-12 p-md-4 p-pt-2">
                    <div className="p-w-100">
                        <div className="custom-inputs">
                            <ColorPicker
                                value={color?.replace("#", "")}
                                onChange={(e) => handleColorChange(e, 'ColorCode')}
                            />
                            <label htmlFor="ColorCode" className="p-ml-2">House Color Code</label>
                            <InputText
                                className="p-mt-2 p-w-100"
                                id='colorCode'
                                value={color?.toUpperCase()}
                                onChange={(e) => handleColorChange(e, 'ColorCode')}
                                maxLength={8}
                            />
                        </div>
                        <span className="p-error block" style={{ color: 'red' }}>
                            {colorErr ? colorErrText : null}
                        </span>
                    </div>
                </div>
                <div className="p-col-12 p-md-4 p-pt-2">
                    <div className="p-w-100">
                        <div className="custom-inputs">
                            <ColorPicker
                                value={nameColor?.replace("#", "")}
                                onChange={(e) => handleColorChange(e, 'NameColor')}
                            />
                            <label htmlFor="NameColorCode" className="p-ml-2">Text Color Code</label>
                            <InputText
                                className="p-mt-2 p-w-100"
                                value={nameColor?.toUpperCase()}
                                onChange={(e) => handleInputChange(e, 'NameColor')}
                                maxLength={8}
                                onKeyDown={(e) => {
                                    if (e.key === 'Tab' && !e.shiftKey) {
                                        e.preventDefault();
                                        if (submitButtonRef.current) {
                                            submitButtonRef.current.focus();
                                        }
                                    }
                                }}
                            />
                        </div>
                        <span className="p-error block" style={{ color: 'red' }}>
                            {nameColorErr ? nameColorErrText : null}
                        </span>
                    </div>
                </div>
                <div className="p-col-12 p-md-6 p-pt-2">
                    <UploadFile label='Background Image' note='(Select 1:1 ratio image)' preview={previewProfilePath} original={backgroundImage} uploadHandler={handleBackGroundImage} uploadRef={fileUploadRef} handleDelete={handleDelete} isEditAllow={true} aspectRatio={1 / 1} />
                </div>
            </div>
            <div className='dialog-footer p-d-flex p-ai-center p-jc-end'>
                <Button className='p-m-0 btn-text-action-secondary p-m-1' onClick={(e) => onCancel()}> Cancel </Button>
                <Button ref={submitButtonRef} className='p-m-0 btn-text-action-primary submit-focus' label="Submit" severity="secondary" raised onClick={(e) => AddHouseMaster()} />
            </div>

            <Dialog
                visible={isDeleteConfirmation}
                onHide={handleClose}
                header={
                    <div className="p-d-flex p-jc-between p-ai-center">
                        <span>Delete Confirmation</span>
                    </div>
                }
                footer={renderFooter()}
                draggable={false}
                dismissableMask
                position="center"
                style={{ width: '450px' }}
            >
                <DeleteConfirmation />
            </Dialog>
        </div>
    );
};

export default AddHouseMasterDialog;
